<div class="wrapper">
    <div  class="divwrapper" *ngIf="(branchOutside ? branchOutside.temperaturepresent.constvalue.value : 0)">
      Temperature
      <kendo-arcgauge style="display:block;height:125px;width:125px;"   [value]="outsideTemperature.val" [scale]="{ min:-25, max: 50 }">
        <ng-template   kendoArcGaugeCenterTemplate   let-value="value" >
          <span >{{ GetValue(outsideTemperature) }} <app-unit *ngIf="branchOutside" [unit]="branchOutside.outsidetemp.variable.unit"></app-unit> </span>
        </ng-template>
      </kendo-arcgauge>

    </div>
    <div  class="divwrapper" *ngIf="(branchOutside ? branchOutside.humiditypresent.constvalue.value : 0)">
      Humidity
      <kendo-arcgauge style="display:block;height:125px;width:125px;"  [value]="outsideHumidity.val" [scale]="{ min: 0, max: 100 }">
        <ng-template   kendoArcGaugeCenterTemplate   let-value="value" >
          <span >{{ GetValue(outsideHumidity) }} <app-unit *ngIf="branchOutside" [unit]="branchOutside.outsidehumidity.variable.unit"></app-unit></span>
        </ng-template>
      </kendo-arcgauge>
    </div>
</div>



<div class="wrapper">
  <div  class="divwrapper" *ngIf="(branchOutside ? branchOutside.radiationpresent.constvalue.value : 0)">
    Solar Direct
    <kendo-arcgauge style="display:block;height:125px;width:125px;"   [value]="radiation.val" [scale]="{ min:0, max: 1100 }">
      <ng-template   kendoArcGaugeCenterTemplate   let-value="value" >
        <span >{{ GetValue(radiation) }} <app-unit *ngIf="branchOutside" [unit]="branchOutside.radiation.variable.unit"></app-unit> </span>
      </ng-template>
    </kendo-arcgauge>

  </div>
  <div  class="divwrapper" *ngIf="(branchOutside ? branchOutside.radiationpresent.constvalue.value : 0)">
    Solar Sum
    <kendo-arcgauge style="display:block;height:125px;width:125px;"  [value]="radiationsum.val" [scale]="{ min: 0, max: 1100 }">
      <ng-template   kendoArcGaugeCenterTemplate   let-value="value" >
        <span >{{ GetValue(radiationsum) }} <app-unit *ngIf="branchOutside" [unit]="branchOutside.radiationsum.variable.unit"></app-unit></span>
      </ng-template>
    </kendo-arcgauge>
  </div>
</div>







<div class="wrapper" *ngIf="(branchOutside ? branchOutside.humiditypresent.constvalue.value : 0)">
  <div class="divwrapper">
    Dewpoint:
    <div  class="divwrapper" >
      {{ GetValue(dewPoint) }}
    </div>
  </div>
  <app-unit *ngIf="branchOutside" [unit]="branchOutside.dewpoint.variable.unit"></app-unit>
</div>
<div class="wrapper">
  <div class="divwrapper">
    Abs. humidity :
    <div  class="divwrapper" >
      {{ GetValue(absHumidity) }}
    </div>
  </div>
  <app-unit *ngIf="branchOutside" [unit]="branchOutside.abshumidity.variable.unit"></app-unit>
</div>


<div id="wrap">
  <div id="one">
    <fa-icon [icon]="iconSun" size="1x"></fa-icon>
  </div>
  <div id="two">
    {{ GetTime(sunRise) }}
  </div>
  <div id="three">
  </div>
  <div id="four">
    <fa-icon [icon]="iconMoon" size="1x"></fa-icon>
  </div>
  <div id="five">
    {{ GetTime(sunSet) }}
  </div>
</div>


